import React, { useState, useCallback, useEffect } from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useEmblaCarousel from "embla-carousel-react";

const girls = [
  {
    id: 1,
    name: "Mey",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/asianb.mp4"
  },
  {
    id: 2,
    name: "Nicol",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/caucasian.mp4"
  },
  {
    id: 3,
    name: "Jessica",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/afro.mp4"
  },
  {
    id: 4,
    name: "Vanessa",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/latino.mp4"
  }
];

const Step2 = ({ onSelectGirl }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    loop: true,
    containScroll: 'trimSnaps',
    slidesToScroll: 1
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCurrentIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  const handleContinue = () => {
    onSelectGirl(girls[currentIndex]);
  };

  const scrollTo = useCallback((index) => {
    if (emblaApi) emblaApi.scrollTo(index);
  }, [emblaApi]);

  return (
    <div className="step-container step2">
      <div className="step2-content">
        <h2 className="step2-title">Choose your slut for tonight</h2>
        
        <div className="new-carousel-wrapper">
          <button
            onClick={scrollPrev}
            className="carousel-arrow carousel-arrow-left"
            aria-label="Previous"
          >
            <ChevronLeft size={32} />
          </button>

          <div className="carousel-embla" ref={emblaRef}>
            <div className="carousel-embla__container">
              {girls.map((girl, index) => (
                <div className="carousel-embla__slide" key={girl.id}>
                  <div className="video-card">
                    <div className="video-placeholder" data-index={index}></div>
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="video-element"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    >
                      <source src={girl.video} type="video/mp4" />
                    </video>
                    <div className="video-text-overlay">
                      <h3 className="video-name">{girl.name}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={scrollNext}
            className="carousel-arrow carousel-arrow-right"
            aria-label="Next"
          >
            <ChevronRight size={32} />
          </button>
        </div>

        <div className="carousel-pagination">
          {girls.map((_, index) => (
            <button
              key={index}
              onClick={() => scrollTo(index)}
              className={`pagination-dot ${index === currentIndex ? "pagination-dot-active" : ""}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        <Button
          onClick={handleContinue}
          className="btn-continue"
          size="lg"
        >
          CONTINUE WITH HER →
        </Button>
      </div>
    </div>
  );
};

export default Step2;
